const API = '/api';
const AMBIENT = process.env.REACT_APP_AMBIENT;
const APP_HOST = process.env.REACT_APP_HOST;
const LOGIN_API_HOST = process.env.REACT_APP_LOGIN_HOST;
const USERS_API_HOST = process.env.REACT_APP_USERS_HOST;
const SHIPS_API_HOST = process.env.REACT_APP_SHIPS_HOST;
const ARGENTINADATOS_URL = process.env.REACT_APP_ARGENTINADATOS_URL;
const ASISTENTE_IA_URL = process.env.REACT_APP_ASISTENTE_IA_URL;

const ASISTENTE_IA_PROFILE =
    process.env.REACT_APP_ASISTENTE_IA_PROFILE || '{"apps": ["SIMP"], "area": "BACKOFFICE"}';

export const settings = {
    ambient: AMBIENT,
    url: {
        host: APP_HOST,
        loginAPI: LOGIN_API_HOST,
        usersAPI: USERS_API_HOST,
        shipsAPI: SHIPS_API_HOST,
        api: API,
        argentinadatos: ARGENTINADATOS_URL,
        asistenteIA: ASISTENTE_IA_URL
    },
    asistenteIA: {
        profile: ASISTENTE_IA_PROFILE
    }
};
